import { EventEmitter, Injectable } from '@angular/core';
import { Product } from '../_model/product';
// import { productsArray } from '../_mock-db/mock-db';
import { HttpClient } from '@angular/common/http';
import { baseUrl } from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  sameProductPressed = new EventEmitter<string>();
  constructor(private http: HttpClient) {}

  // getProductById(id): Product {
  //   return productsArray.find((product) => product.id == id);
  // }

  getProductByName(name: string) {
    // return productsArray.find((product) => product.domain.toLowerCase() == name.toLowerCase());
    return this.http.get(`${baseUrl}/Products/GetProductByName/${name}`);
  }

  getProductBySubDomain(subDomain: string){
    return this.http.get(`${baseUrl}/Products/GetProductByDomain/${subDomain}`);

  }

  emitSameProduct(domainName){
    this.sameProductPressed.emit(domainName);
  }
  // getRelatedProducts(id): Product[] {
  //   const product = this.getProductById(id);
  //   return product.relatedProducts.map((p) => this.getProductById(p));
  // }
}
